import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { InventoryListTemplate } from "./InventoryListTemplate";
import { INVENTORY_LIST_ROW_CONTENT_PX } from "./inventoryList.utils";

const BAR_AREAS: [string, number | string][] = [
  ["sku", "70%"],
  ["product", "60%"],
  ["location", "75%"],
  ["status", 72],
  ["cin7", "50%"],
  ["threePl", "60%"],
  ["difference", "40%"],
];

/** A placeholder inventory row, as tall as a collapsed InventoryListRow, shown while a page loads. */
export const InventoryListSkeletonRow = () => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <InventoryListTemplate
        sx={{
          height: INVENTORY_LIST_ROW_CONTENT_PX,
          py: 0.5,
        }}
      >
        <Skeleton
          height={20}
          sx={{ gridArea: "expand" }}
          variant="circular"
          width={20}
        />
        {BAR_AREAS.map(([area, width]) => (
          <Skeleton
            height={24}
            key={area}
            sx={{
              gridArea: area,
              justifySelf: area === "cin7" || area === "threePl" || area === "difference" ? "end" : "start",
            }}
            width={width}
          />
        ))}
      </InventoryListTemplate>
    </Box>
  );
};
